/**
 * @author      david.loehr@zumper.com (David Loehr)
 * @copyright   Copyright (c) 2022, Zumper
 * @description CarouselV4 component
 */

import { ChevronRight } from '@zcode-ui/icons'
import { capitalize } from '@zcode/utils'
import React from 'react'
import { twMerge } from 'tailwind-merge'
import './CarouselV4.css'

export type Type = 'previous' | 'next'
export interface CarouselV4ButtonProps {
  onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void
  onKeyDown?: (e: KeyboardEvent | React.KeyboardEvent) => void
  type: Type
}

export const CarouselV4Button = ({
  onClick,
  onKeyDown,
  type,
}: CarouselV4ButtonProps) => {
  return (
    <button
      className={twMerge(
        'carousel-button inline-flex appearance-none items-center justify-center select-none whitespace-nowrap align-middle outline-transparent outline-2 outline-offset-2 leading-[0.9] bg-gray-150 absolute top-1/2 h-6 min-w-[24px] opacity-0 m-0 p-0 rounded-[159984px] w-6 border-none cursor-pointer transition-opacity duration-300 ease-in translate-y-[-50%] hover:bg-gray-50 active:bg-blue-800',
        'after:content-[""] after:absolute after:size-[14px]',
        type === 'previous' ? 'left-4 scale-x-[-1]' : 'right-4'
      )}
      aria-label={`${capitalize(type)} Item`}
      type="button"
      onClick={onClick}
      onKeyDown={onKeyDown}
    >
      <ChevronRight style={{ marginRight: '2px' }} />
    </button>
  )
}
